export default __webpack_public_path__ + "static/media/981.44180a3a.jpg";